import React, { useState } from "react";
import "./Register.css";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import axios from "axios";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { storeToken } from "../utils/AuthStorage";

const Register = () => {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileCode: "+91",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
      return;
    }

    setLoading(true);
    const data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobileCode: formData.mobileCode,
      mobile: formData.mobile,
      email: formData.email,
      password: formData.password,
    };

    try {
      const response = await axios.post(
        "https://expense.dpstrust.in/api/user/register",
        data,
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response?.data?.message || "Registered Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Bounce,
      });
    //   storeToken(response.data.data.token);
    //   navigate('/')
      navigate("/welcome");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Registration Failed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const countryCodes = [
    { code: "+91", label: "India (+91)" },
    { code: "+1", label: "USA (+1)" },
    { code: "+44", label: "UK (+44)" },
    { code: "+61", label: "Australia (+61)" },
    { code: "+971", label: "UAE (+971)" },
  ];

  return (
    <div className="register-container">
      <ToastContainer />
      <form className="register-form" onSubmit={handleSubmit}>
        <h2>Register</h2>
        <div className="register-input-group">
          <label className="register-label" htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            className="register-input"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="register-input-group">
          <label className="register-label" htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            className="register-input"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <label className="register-label" htmlFor="mobileCode">Mobile Code</label>
        <div className="register-input-group-inline">

          <div className="register-inline">
            <select
              id="mobileCode"
              name="mobileCode"
              className="register-select"
              value={formData.mobileCode}
              onChange={handleInputChange}
              required
            >
              {countryCodes.map((country) => (
                <option key={country.code} value={country.code}>
                  {country.code}
                </option>
              ))}
            </select>
          </div>
          <div className="register-inline1">
            <input
              type="text"
              id="mobile"
              name="mobile"
              className="register-input-inline"
              value={formData.mobile}
              maxLength={10}
              onChange={handleInputChange}
              required
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
            />
          </div>
        </div>
        <div className="register-input-group">
          <label className="register-label" htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            className="register-input"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="register-input-group">
          <label className="register-label" htmlFor="password">Password</label>
          <div className="register-password-container">
            <input
              type={passwordVisible ? "text" : "password"}
              id="password"
              name="password"
              className="register-input"
              value={formData.password}
              onChange={handleInputChange}
              required
            />
            <span className="register-eye-icon" onClick={togglePasswordVisibility}>
              {passwordVisible ? <IoEyeOutline /> : <IoEyeOffOutline />}
            </span>
          </div>
        </div>
        <div className="register-input-group">
          <label className="register-label" htmlFor="confirmPassword">Confirm Password</label>
          <input
            type={passwordVisible ? "text" : "password"}
            id="confirmPassword"
            name="confirmPassword"
            className="register-input"
            value={formData.confirmPassword}
            onChange={handleInputChange}
            required
          />
        </div>
        <button type="submit" className="register-button" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
        <p className="toggle-text">
        Already have an account?
          <span
            className="toggle-link" onClick={()=> navigate(`/login`)}
          >
            Login
          </span>
        </p>
      </form>
    </div>
  );
};

export default Register;
